import React, { useEffect } from "react";
import { Outlet } from "react-router";

import { useAppDispatch } from "store/hooks";

import { getUser } from "store/features/userSlice";
import { setLoading } from "store/features/globalLoadingSlice";
import { getIbanAccounts } from "store/features/ibanAccountSlice";
import { getSubscription } from "store/features/subscriptionSlice";
import { getInvoiceExpirationSettings } from "store/features/invoiceExpirationSettingsSlice";

const CabinetDataLoader: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setLoading(true));
    Promise.all([
      dispatch(getUser()),
      dispatch(getIbanAccounts()),
      dispatch(getSubscription()),
      dispatch(getInvoiceExpirationSettings()),
    ]).finally(() => {
      dispatch(setLoading(false));
    });
  }, []);

  return <Outlet />;
};

export default CabinetDataLoader;
